import ReactGA from 'react-ga4';

export const initReactGA = () => {
    if (process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID && process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID !== '') {
        ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID);
    }
}